<template>
  <a-spin :spinning="spinning">
  <div :class="{'over-view-panel': !mobileFlag}">
<!--    <div :class="{'search-panel-mobile': mobileFlag, 'search-panel-pc': !mobileFlag}">-->
<!--      <a-input-search placeholder="input search text" -->
<!--                      @search="convertOriginalData" size="small">-->
<!--      </a-input-search>-->
<!--    </div>-->
    <a-tabs   defaultActiveKey="3" v-model="defaultActiveKey" @change="callback">
      <a-tab-pane v-for="(item,index) in readingPlanOverviews" :key="index + 1 + ''">
        <span slot="tab" :title="item.bookName">
          <a-icon v-if="item.myRole === '2_OBSERVER' ||
          item.myRole === '9CMP_2_OBSERVER'" type="eye" >
          </a-icon>
          {{ item.bookShortName + '-' + item.adminName }}
        </span>
      </a-tab-pane>
    </a-tabs>
    <div :class="[{'status-show-mobile': mobileFlag},'status-show']">
      <span class="status-title">已反馈</span>
      <span class="status-span">
        <a-icon type="flag" theme="twoTone" twoToneColor="#52c41a"/>
      </span>
      <span class="status-title">待反馈</span>
      <span class="status-span">
        <a-icon type="flag" theme="twoTone" twoToneColor="#FFC125"/>
      </span>
      <span class="status-title">未提交</span>
      <span class="status-span">
        <a-icon type="flag" theme="twoTone" twoToneColor="#b90b14"/>
      </span>
    </div>
    <div class="table" ref="imageWrapper">
      <a-table :columns="columns" :dataSource="data" :scroll="{ x: width}"
               :pagination="false" rowKey="id" :loading="loading" >
        <span slot="customTitle"> {{currentChapter}}
          <a-icon theme="twoTone" twoToneColor="#52c41a" type="pushpin" />
        </span>
        <template slot="name" slot-scope="text, record">
          <span v-if="record.myStudent" style="background-color: #52c41a">{{text}}
          </span>
          <span v-if="!record.myStudent">{{text}}
          </span>
        </template>
        <template slot="chapterStatus" slot-scope="text, record" >
          <span v-if="text.status === 'COMMENTED'" style="cursor: pointer"
                @click="showModal(text.feedbackId, record.id)" class="table-status-span">
             <a-icon type="flag" theme="twoTone" twoToneColor="#52c41a"/>
          </span>
          <span v-else-if="text.status === 'NOT_COMMENT'" style="cursor: pointer"
                @click="showModal(text.feedbackId, record.id)" class="table-status-span">
            <a-icon type="flag" theme="twoTone" twoToneColor="#FFC125"/>
          </span>
          <span v-else-if="text.status === 'NOT_FEEDBACK'" class="table-status-span">
            <a-icon type="flag" theme="twoTone" twoToneColor="#b90b14"/>
          </span>
          <span v-else class="table-status-span">
            <a-icon type="flag" theme="twoTone" twoToneColor="#CDC5BF"/>
          </span>
        </template>
      </a-table>
    </div>
    <div>
      <a-button shape="circle"
                :class="{'pc-refresh-button': !mobileFlag, 'mobile-refresh-button': mobileFlag}"
                title="刷新" type="primary" @click="refresh()">
        <a-icon style="position: relative;"
                :class="{'pc-refresh-icon': !mobileFlag, 'mobile-refresh-icon': mobileFlag}"
                type="redo" />
      </a-button>
    </div>
    <a-tag @click="toImage" class="to-image-tag">生成图片</a-tag>
<!--    <div class="pagination">-->
<!--      <a-pagination-->
<!--        :total="85"-->
<!--        :showTotal="total => `Total ${total} items`"-->
<!--        :pageSize='pageSize'-->
<!--        :defaultCurrent="1"-->
<!--        @showSizeChange="onChangePageSizeChange"-->
<!--        @change="onChange"-->
<!--        size="small"-->
<!--        showQuickJumper-->
<!--        showSizeChanger/>-->
<!--    </div>-->
    <a-modal title="读书反馈" v-model="visible" @ok="submitComment()"
             okText="提交" cancelText="取消" :maskClosable=maskClosable>
      <div class="report-panel">
        <div class="report-panel-title">
            <span class="report-panel-week">
              第
              <span style="color: #42b983;font-size: 14px">
                {{ currentChapterNum }}
              </span>{{ cycleValue }}</span>
<!--          <span class="report-title">主题</span>-->
          <span class="report-title-content">{{ currentChapterTitle }}</span>
<!--          <a-tag class="report-status" :color="reportStatusColor">-->
<!-- <a-icon :type="reportStatusIcon === null ? 'check' : reportStatusIcon" />&ndash;&gt;-->
<!--            {{ currentReportStatus }}-->
<!--          </a-tag>-->
          <div class="report-status">
            <!--              <a-icon :type="reportStatusIcon" />-->
            <!--              {{ currentReportStatus }}-->
            <span class="status-title"> {{ currentReportStatus }}</span>
            <span class="status-span">
                <a-icon type="flag" theme="twoTone" :twoToneColor="reportStatusColor"/>
              </span>
          </div>
        </div>
        <div class="report-panel-item"
             v-for="(item,index) in feedbackItems" v-bind:key="index">
          <span class="input-title" v-html="item.label"></span>
          <a-textarea placeholder="" :autosize="{ minRows: 4 }"
                      readonly="readonly" v-model="item.content">
          </a-textarea>
        </div>
        <div class="report-panel-item"
             v-for="(item,index) in feedBackComments" :key="index + 100">
          <span class="input-title review-title">反馈</span>
          <span class="teacher-name"> {{ item.userName }}</span>
          <a-textarea :autosize="{ minRows: 4}"
                      :readonly="item.userName !== currentUserName"
                      style="border: 1px solid #1890ff;" v-model="item.content">
          </a-textarea>
        </div>
        <div v-if="currentReportStatus === '已反馈'" class="share-panel">
          <span class="share-span">分享：</span>
          <a-icon class="share-icon"  @click="toSharePage" type="share-alt" />
        </div>
        <input type="hidden" value="ioqrioqropi" class="copy-input">
      </div>
<!--      <button type="button" id="copy-btn"-->
<!--              v-clipboard:copy="copyData"-->
<!--              v-clipboard:success="onCopy"-->
<!--              v-clipboard:error="onError">Copy!</button>-->
<!--      <button type="button" id="copy-btn" @click="doCopy">Copy!</button>-->
      <a-button class="copy-btn"  size="small" @click="doCopy"><a-icon type="copy" />复制反馈</a-button>
    </a-modal>
  </div>
  </a-spin>
</template>

<script>
import html2canvas from 'html2canvas';
import store from '../store';
import service from '../axios/reponse';

export default {
  name: 'class-overview',
  data() {
    return {
      maskClosable: false,
      visible: false,
      page: 1,
      pageSize: 10,
      width: 1,
      currentChapterTitle: '',
      currentReportStatus: '',
      reportStatusColor: '',
      reportStatusIcon: 'check',
      feedbackItems: [],
      feedBackComments: [],
      readingFeedBackDetailDto: [],
      mobileFlag: false,
      columns: [],
      data: [],
      currentChapterNum: 0,
      dataId: '',
      currentChapter: 5,
      loading: true,
      feedbackId: '',
      readingPlanId: '',
      currentUserName: '',
      imgUrl: '',
      dataLength: '',
      readingPlanOverviews: '',
      copyData: 'hahaa',
      spinning: false,
      cycleValue: '周',
      defaultActiveKey: '1',
    };
  },
  created() {
    const key = localStorage.getItem('key');
    if (key !== null) {
      this.defaultActiveKey = key;
    }
    this.getReadingPlanOverviews();
    // this.getReadingPlanId();
    this.adaptMobile();
    console.log(localStorage.getItem('key'));
  },
  mounted() {
    this.visible = true;
    this.visible = false;
  },
  methods: {
    showModal(index, id) {
      this.dataId = id - 1;
      this.getFeedBackById(index);
      this.feedBackId = index;
      this.visible = true;
    },
    hideModal() {
      this.visible = false;
    },
    // onChange(page, pageSize) {
    //   this.page = page;
    //   console.log(`当前页码:${this.page}`);
    //   this.pageSize = pageSize;
    //   console.log(`每页条数:${this.pageSize}`);
    // },
    // onChangePageSizeChange(current, size) {
    //   console.log(current);
    //   this.pageSize = size;
    //   console.log(size);
    // },
    onSearch(value) {
      console.log(value);
    },
    async getFeedBackById(id) {
      this.axios.get(`service/feedback/${id}`).then((response) => {
        if (response.data.code === 0) {
          this.readingFeedBackDetailDto = response.data.data;
          // eslint-disable-next-line max-len
          this.feedbackItems = this.readingFeedBackDetailDto.items.sort((a, b) => a.sequence - b.sequence);
          this.feedBackComments = this.readingFeedBackDetailDto.comments;
          this.currentChapterNum = this.readingFeedBackDetailDto.chapter.chapterNo;
          this.currentChapterTitle = this.readingFeedBackDetailDto.chapter.name;
          const { status } = this.readingFeedBackDetailDto;
          if (status === 'COMMENTED') {
            this.currentReportStatus = '已反馈';
            this.reportStatusColor = '#58b935';
            this.reportStatusIcon = 'check';
          } else if (status === 'NOT_COMMENT') {
            this.currentReportStatus = '待反馈';
            this.reportStatusColor = '#FFC125';
            this.reportStatusIcon = 'exclamation';
          } else {
            this.currentReportStatus = '未提交';
            this.reportStatusColor = '#b90b14';
            this.reportStatusIcon = 'close';
          }
          // 处理commentsList最后一个元素
          let flag = 0;
          for (let i = 0; i < this.feedBackComments.length; i += 1) {
            const { userName } = this.feedBackComments[i];
            if (userName === null
              || userName === this.currentUserName) {
              console.log(this.feedBackComments[i]);
              this.feedBackComments[i].userName = this.currentUserName;
              const tempFeedBackComment = this.feedBackComments[i];
              this.feedBackComments.splice(i, 1);
              this.feedBackComments.push(tempFeedBackComment);
              flag = 1;
              break;
            }
          }
          if (flag === 0) {
            const lastFeedBackComment = {
              id: null,
              submitTime: null,
              content: null,
              userId: store.state.user.userId,
              userName: this.currentUserName,
              feedbackId: this.feedBackComments[0].feedbackId,
            };
            this.feedBackComments.push(lastFeedBackComment);
          }
        } else {
          this.$message.error('获取失败！');
        }
      }).catch((response) => {
        console.log(response);
      });
    },
    async submitComment() {
      this.spinning = true;
      // const data = this.$qs.stringify(this.readingFeedBackDetailDto);
      this.axios({
        method: 'post',
        url: '/service/comment/submit',
        data: this.feedBackComments[this.feedBackComments.length - 1],
      }).then((response) => {
        if (response.data.code === 0) {
          this.data[this.dataId][`chapter${this.currentChapterNum}`].status = 'COMMENTED';
          this.visible = false;
          // this.$copyText('this.message').then((e) => {
          //   console.log(e);
          // }, (e) => {
          //   console.log(e);
          // });
          this.spinning = false;
          this.showConfirm();
          // this.$message.success('反馈成功！');
        } else {
          this.spinning = false;
          this.$message.error('反馈失败！');
        }
      }).catch((response) => {
        this.spinning = false;
        this.$message.error('服务器发生错误');
        console.log(response);
      });
    },
    async getReadingPlanOverviews() {
      const res = await service({
        methods: 'get',
        url: '/service/reading/plan/overview',
      });
      if (res.code === 0) {
        this.readingPlanOverviews = res.data;
        if (this.dedefaultActiveKey > this.readingPlanOverviews.length) {
          this.dedefaultActiveKey = 1;
        }
        this.readingPlanId = res.data[this.defaultActiveKey - 1].planId;
        this.getCurrentChapter(this.readingPlanId);
        this.getOriginalData(this.readingPlanId);
      }
      if (res.code === 1) {
        this.$message.error(res.msg);
      }
    },
    async getOriginalData(id) {
      const res = await service({
        method: 'get',
        url: `/service/readingplan/${id}`,
      });
      if (res.code === 0) {
        this.convertOriginalData(res.data);
        this.currentUserName = store.state.user.name;
      }
      if (res.code === 1) {
        this.$message.error('获取失败！');
      }
      // await this.axios.get(`/service/readingplan/${id}`).then((response) => {
      //   if (response.data.code === 0) {
      //     this.convertOriginalData(response.data.data);
      //   } else {
      //     this.$message.error('获取失败！');
      //   }
      // }).catch((response) => {
      //   console.log(response);
      // });
    },
    async getCurrentChapter(id) {
      await this.axios.get(`/service/currentChapter/${id}`).then((response) => {
        if (response.data.code === 0) {
          this.currentChapter = response.data.data.currentChapter;
          const tempCycleValue = response.data.data.cycleDays;
          if (tempCycleValue === 1) {
            this.cycleValue = '天';
          } else if (tempCycleValue === 7) {
            this.cycleValue = '周';
          } else if (tempCycleValue === 30 || tempCycleValue === 31) {
            this.cycleValue = '月';
          } else {
            this.cycleValue = '章';
          }
        } else {
          this.$message.error('获取失败！');
        }
      }).catch((response) => {
        console.log(response);
      });
    },
    convertOriginalData(originalData) {
      let id = 0;
      const columnFeedBacks = originalData[0].feedbacks;
      console.log(columnFeedBacks.length);
      let width = '70px';
      let fixed = false;
      if (columnFeedBacks.length < 13 && this.mobileFlag) {
        width = '50px';
      }
      if (columnFeedBacks.length >= 13 && this.mobileFlag) {
        width = '50px';
        fixed = true;
      }
      if (columnFeedBacks.length > 48 && !this.mobileFlag) {
        width = '50px';
        fixed = true;
      }
      this.columns = [{
        title: '姓名',
        dataIndex: 'userName',
        // columnWidth: '100px',
        // width: '50px',

        // align: 'left',
        scopedSlots: { customRender: 'name' },
        width,
        className: 'week-num-col user-name-col',
        fixed,
      }];
      for (let i = 0; i < columnFeedBacks.length; i += 1) {
        const tempColumn = { scopedSlots: { customRender: 'chapterStatus' } };
        if (columnFeedBacks[i].chapter.chapterNo === this.currentChapter) {
          tempColumn.slots = { title: 'customTitle' };
        } else {
          tempColumn.title = columnFeedBacks[i].chapter.chapterNo;
        }
        tempColumn.dataIndex = `chapter${columnFeedBacks[i].chapter.chapterNo}`;
        tempColumn.className = 'week-num-col';
        this.columns.push(tempColumn);
      }
      this.data = [];
      this.dataLength = originalData.length;
      for (let j = 0; j < originalData.length; j += 1) {
        const { feedbacks } = originalData[j];
        const tempData = {
          id: id += 1,
          userId: originalData[j].userId,
          userName: originalData[j].userName,
          myStudent: originalData[j].myStudent,
        };
        for (let i = 0; i < feedbacks.length; i += 1) {
          if (feedbacks[i].chapter.chapterNo <= this.currentChapter) {
            tempData[`chapter${feedbacks[i].chapter.chapterNo}`] = {
              status: feedbacks[i].status,
              feedbackId: feedbacks[i].id,
            };
          } else {
            tempData[`chapter${feedbacks[i].chapter.chapterNo}`] = {
              status: 'AFTER_CURRENT',
              feedbackId: feedbacks[i].id,
            };
          }
        }
        this.data.push(tempData);
      }
      this.loading = false;
      console.log(this.data);
    },
    toSharePage() {
      if (this.mobileFlag) {
        this.$router.push(`/share/${this.feedBackId}`);
      } else {
        const routeData = this.$router.resolve({ path: `/share/${this.feedBackId}` });
        window.open(routeData.href, '_blank');
      }
    },
    getReadingPlanId() {
      this.readingPlanId = store.state.readingPlanId;
    },
    showConfirm() {
      const that = this;
      this.$confirm({
        title: '提交成功,要分享这个反馈吗?',
        onOk() {
          that.toSharePage();
        },
        onCancel() {
          console.log('Cancel');
        },
      });
    },
    toImage() {
      let yLength = 150;
      console.log(window.pageYOffset);
      console.log(this.$refs.imageWrapper.scrollHeight);
      if (window.pageYOffset > 300) {
        yLength = window.pageYOffset - 220;
      }
      // yLength = this.$refs.imageWrapper.scrollHeight - window.pageYOffset - 150;
      // else {
      //   yLength = window.pageYOffset - 210;
      // }
      html2canvas(this.$refs.imageWrapper, {
        useCORS: true,
        windowWidth: this.$refs.imageWrapper.scrollWidth,
        windowHeight: this.$refs.imageWrapper.scrollHeight,
        x: 0,
        // y: window.pageYOffset - 210,
        y: yLength,
      }).then((canvas) => {
        // eslint-disable-next-line no-undef,no-param-reassign
        // canvas.style.width = '3000px';
        this.imgUrl = canvas.toDataURL('image/png');
        if (this.imgUrl !== '') {
          window.location.href = this.imgUrl;
        }
        this.downloadFile('课堂回顾.png', this.imgUrl);
      });
    },
    downloadFile(fileName, content) {
      const aLink = document.createElement('a');
      const blob = this.base64ToBlob(content); // new Blob([content]);

      const evt = document.createEvent('HTMLEvents');
      evt.initEvent('click', true, true);// initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
      aLink.download = fileName;
      aLink.href = URL.createObjectURL(blob);

      // aLink.dispatchEvent(evt);
      aLink.click();
      aLink.remove();
    },
    // base64转blob
    base64ToBlob(code) {
      const parts = code.split(';base64,');
      const contentType = parts[0].split(':')[1];
      const raw = window.atob(parts[1]);
      const rawLength = raw.length;

      const uInt8Array = new Uint8Array(rawLength);

      for (let i = 0; i < rawLength; i += 1) {
        uInt8Array[i] = raw.charCodeAt(i);
      }
      return new Blob([uInt8Array], { type: contentType });
    },
    callback(key) {
      // eslint-disable-next-line no-param-reassign
      localStorage.setItem('key', key);
      this.loading = true;
      this.readingPlanId = this.readingPlanOverviews[key - 1].planId;
      this.getCurrentChapter(this.readingPlanId);
      this.getOriginalData(this.readingPlanId);
      console.log(key);
    },
    refresh() {
      this.getCurrentChapter(this.readingPlanId);
      this.getOriginalData(this.readingPlanId);
      this.$message.success('刷新成功！');
    },
    // onCopy(e) {
    //   alert(`You just copied: ${e.text}`);
    // },
    // onError(e) {
    //   alert('Failed to copy texts');
    // },
    doCopy() {
      const copyValue = this.feedBackComments[this.feedBackComments.length - 1].content;
      this.$copyText(copyValue).then((e) => {
        this.$message.success('复制成功');
        console.log(e);
      }, (e) => {
        this.$message.error('复制失败');
        console.log(e);
      });
    },
    adaptMobile() {
      if (this.isMobile()) {
        this.mobileFlag = true;
      }
    },
  },
};
</script>

<style scoped>
  .search-panel-pc{
    width: 200px;
    margin-bottom: -20px;
  }
  .search-panel-mobile{
    width: 280px;
    position: relative;
    top: -10px;
    margin-top: 30px;
  }
  .over-view-panel{
    padding: -15px 10% 0 10%;
  }
.pagination{
  margin-top: 20px;
  position: relative;
  right: 5px;
  float: right;
}
  .status-span {
    cursor: pointer;
    /*padding: 1px 3px 2px 3px;*/
    /*background: #58b935;*/
    /*border-radius: 10px;*/
    /*color: #ffffff;*/
    /*font-size: 12px;*/
    font-size: 18px !important;
    margin-left: 4px;
    position: relative;
    top:1px;
  }
  .table-status-span {
    font-size: 18px;
    position: relative;
    top:1px;
    left: -2px;
    width: 3px;
  }
  .error-span {
    cursor: pointer;
    padding: 1px 3px 2px 3px;
    background: #b90b14;
    border-radius: 10px;
    color: #ffffff;
    font-size: 12px;
  }
  .warning-span {
    cursor: pointer;
    padding: 1px 3px 2px 3px;
    background: #b94b0e;
    border-radius: 10px;
    color: #ffffff;
    font-size: 12px;
  }
  .status-show{
    float: right;
    margin-bottom: 10px;
    margin-top: -5px;
  }
  .status-show-mobile{
    margin-right: 10px;

  }
  .status-title{
    margin-right: 4px;
    margin-left: 15px;
    font-size: 14px !important;
  }
  .report-panel-title span {
    font-size: 20px;
  }
  .report-title{
    margin-left: 30px;
    margin-right: 10px;
    font-size: 14px !important;
  }
  .report-title-content{
    border-bottom: 1px solid #42b983;
    margin-right: 20px;
    font-weight: 600;
  }
  .report-status {
    float: right;
    font-size: 14px !important;
  }
  .report-panel-week{
    font-size: 14px !important;
    margin-right: 15px;
  }
  /*.ant-modal-body {*/
  /*  padding: 10px 24px 24px 24px;*/
  /*}*/
  .report-panel-item{
    margin-top: 15px;
    margin-bottom: 10px;
  }
  .review-title{
    color: #b94b0e;
    font-size: 18px;
  }
  /*.ant-table-thead > tr > th, .ant-table-tbody > tr > td {*/
  /*  padding: 16px 5px !important;*/
  /*}*/
  .share-icon {
    font-size: 20px;
    margin-left: 0;
    position: relative;
    top: 3px;
    cursor: pointer;
  }
  .share-icon:hover {
    color: #42b983;
  }
  .share-panel {
    float: right;
    margin-bottom: 8px;
    position: relative;
    top:-6px;
  }
  .teacher-name{
    float: right;
    position: relative;
    /*color: #b94b0e;*/
    font-weight: 600;
    top:3px;
    border-bottom: 1px solid #42b983;
  }
  /*.ant-table-thead > tr > th, .ant-table-tbody > tr > td {*/
  /*  padding: 16px 0 16px 0 !important;*/
  /*}*/
 .to-image-tag {
   float: right;
   position: relative;
   top: 5px;
   right: -6px;
 }
  .ant-tabs{
    margin-top: -22px !important;
  }
  .copy-btn{
    float: right;
    position: relative;
    top: -5px;
    margin-right: 5px;
  }
  /*.refresh-icon{*/
  /*  background: #fff1e8;*/
  /*}*/
  /*.refresh-icon:hover {*/
  /*  color:  #42b983 !important;*/
  /*}*/
  .pc-refresh-button{
       border: 0;
       font-size: 40px;
       bottom: 120px;
       right: 80px;
       width: 50px;
       height: 50px;
       cursor: pointer;
       position: fixed;
     }
  .mobile-refresh-button{
    border: 0;
    font-size: 30px;
    bottom: 40px;
    right: 40px;
    width: 40px;
    height: 40px;
    cursor: pointer;
    position: fixed;
  }
  .pc-refresh-icon{
    top: -6px;
  }
  .mobile-refresh-icon{
    top: -2px;
  }
</style>
